@if (loading) {
  <tr>
    <td [attr.colspan]="fields.length" class="pt-3 pb-3">
      <div class="text-center c-dark-grey">Загрузка <i class="fa fa-spinner fa-spin"></i></div>
    </td>
  </tr>
}
@if (!onIsNull(rows) && !rows.length && !loading) {
  <tr>
    <td [attr.colspan]="fields.length" class="pt-3 pb-3">
      Записи отсутствуют.
    </td>
  </tr>
}
@if (!onIsNull(rows) && rows && rows.length && !loading) {
  @for (row of rows; track row; let row_index = $index) {
    <tr [ngClass]="{'info': 'info' == row._rowCls}" [attr.data-color]="rowClass?row[rowClass]:''" (click)="rowClick.emit(row)">
      @if (!columns.length) {
        @for (cell of fields; track cell) {
          <td>
            @if (!cell.template) {
              <span>{{row[cell.name]}}</span>
            }
            <div>
              @if (cell.template) {
                <ng-template
                  [ngTemplateOutlet]="cell.template"
                [ngTemplateOutletContext]="{row: row}"></ng-template>
              }
            </div>
          </td>
        }
      }
      @if (columns.length) {
        @for (cell of fields; track cell; let i = $index) {
          <td [attr.data-th]="columns[i].caption"
            [class.data-th]="columns[i].caption">
            @if (!cell.template) {
              <span [innerHtml]="row[cell.name]"></span>
            }
            <div>
              @if (cell.template) {
                <ng-template
                  [ngTemplateOutlet]="cell.template"
                [ngTemplateOutletContext]="{row: row, row_index: row_index}"></ng-template>
              }
            </div>
          </td>
        }
      }
    </tr>
  }
}
